import * as React from 'react';
import { Route, Routes } from 'react-router-dom'
import { coreRoutes } from './routes';
import { corePath } from './index';
import { toRelativeRoute, wrapRoutesWithRouter } from '../shared/utils/routerPaths';

const wrappedCoreRoutes = wrapRoutesWithRouter(coreRoutes)
import { CoreLayout } from './CoreLayout';
import { ErrorBoundary } from '../shared/components/ErrorBoundary';
import { ErrorFallback } from '../shared/components/ErrorFallback';

const CoreModuleImpl: React.FC = () => {
  return (
    <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
      <>
        <>
          <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
            <CoreLayout>
              <Routes>
                {wrappedCoreRoutes.map((route) => (
                        <Route
                      key={route.path}
                      path={`${toRelativeRoute(route.path, corePath)}/*`}
                      element={<route.Component />}
                    />
                      ))}

                {/* fallback */}
                <Route path="*" element={<div>Select</div>} />
              </Routes>
            </CoreLayout>
          </ErrorBoundary>
        </>
      </>
    </ErrorBoundary>
  );
};

export const CoreModule = CoreModuleImpl
